import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const TOOLTIP_STYLE = {
  backgroundColor: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '8px'
};

export const BeneficiaryChart = ({ summary }) => {
  const data = summary ? [
    { name: 'Personal', value: summary.beneficiary_breakdown.me, color: '#10B981' },
    { name: 'Work', value: summary.beneficiary_breakdown.work, color: '#3B82F6' },
    { name: 'Others', value: summary.beneficiary_breakdown.others, color: '#8B5CF6' },
    { name: 'No one', value: summary.beneficiary_breakdown.no_one, color: '#6B7280' }
  ].filter(d => d.value > 0) : [];

  return (
    <Card className="glass border-white/20 dark:border-white/10">
      <CardHeader>
        <CardTitle className="font-['Manrope'] text-lg">Achievement Categories</CardTitle>
        <CardDescription>Who benefits from your achievements</CardDescription>
      </CardHeader>
      <CardContent>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={data} cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={2} dataKey="value">
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip contentStyle={TOOLTIP_STYLE} />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[250px] flex items-center justify-center text-muted-foreground">No achievements yet</div>
        )}
        <div className="flex flex-wrap gap-4 justify-center mt-4">
          {data.map((entry) => (
            <div key={entry.name} className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: entry.color }} />
              <span className="text-sm">{entry.name}: {entry.value}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
